<template src="../../../public/publicSessionWaitingValidation.html">
</template>

<script>

export default {
    name: 'PublicSessionWaitingValidation'
}
</script>
